var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('x-login')],1),_c('div',[_c('x-authorize')],1),_c('div',[_c('x-redirect')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }